import React, { useState } from "react";
import { getCookiePrefs, saveCookiePrefs } from "../../utils/cookieConsent";
import PropTypes from "prop-types";
import "./Cookies.scss";
import { useIntl } from "react-intl";

export default function CookiePreferencesModal({ onClose, onSave }) {
  const existing = getCookiePrefs() || {
    functional: true,
    analytics: false,
    marketing: false,
  };

  const { formatMessage } = useIntl();
  const [analytics, setAnalytics] = useState(existing.analytics);
  const [marketing, setMarketing] = useState(existing.marketing);

  function save() {
    saveCookiePrefs({
      functional: true,
      analytics,
      marketing,
    });
    onSave();
  }

  return (
    <div
      className="overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-modal-title"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="flex modal">
        <h2 id="cookie-modal-title" className="modal-title">
          {formatMessage({ id: "cookieModalTitle" })}
        </h2>

        <div className="item">
          <label className="item-title" htmlFor="cookie-analytics">
            <input
              id="cookie-analytics"
              type="checkbox"
              checked={analytics}
              onChange={(e) => setAnalytics(e.target.checked)}
            />{" "}
            {formatMessage({ id: "cookieModalItem2" })}
          </label>
          <p className="modal-text">
            {formatMessage({ id: "cookieModalText2" })}
          </p>
        </div>

        <div className="item">
          <label className="item-title" htmlFor="cookie-marketing">
            <input
              id="cookie-marketing"
              type="checkbox"
              checked={marketing}
              onChange={(e) => setMarketing(e.target.checked)}
            />{" "}
            {formatMessage({ id: "cookieModalItem3" })}
          </label>
          <p className="modal-text">
            {formatMessage({ id: "cookieModalText3" })}
          </p>
        </div>

        <div className="modal-buttons flex gap-2">
          <button type="button" onClick={onClose} className="btnSecondary">
            {formatMessage({ id: "btnCancelCookies" })}
          </button>
          <button type="button" onClick={save} className="btnPrimary">
            {formatMessage({ id: "btnSaveCookies" })}
          </button>
        </div>
      </div>
    </div>
  );
}

CookiePreferencesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
